import { render, staticRenderFns } from "./ProductSpecsForm.vue?vue&type=template&id=bdc5071a"
import script from "./ProductSpecsForm.vue?vue&type=script&lang=js"
export * from "./ProductSpecsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc5071a')) {
      api.createRecord('bdc5071a', component.options)
    } else {
      api.reload('bdc5071a', component.options)
    }
    module.hot.accept("./ProductSpecsForm.vue?vue&type=template&id=bdc5071a", function () {
      api.rerender('bdc5071a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ProductSpecsForm.vue"
export default component.exports